// Nothing on top of the wait for the first read (#5085, founder pick A,
// 2026-10-21). While /start's one-college-first flow is on screen and its
// first read has not landed, the Astra pill stays hidden (at rest it covered
// the "Read it now" button on a 375 px phone in the mock round) and Astra
// Today's notification ask waits: both finishers on /start saw the ask before
// their read. The ask is held, not dropped: it opens once the read is on
// screen. The launcher and PushAsk are mounted beside the routes, not inside
// /start, so the state is shared here (the quickTourState pattern).
//
// Only the flagged flow sets it; with first_read_onboarding off nothing
// holds, and every surface behaves as before.
import { useSyncExternalStore } from 'react';

let held = false;
const listeners = new Set();

export function isOnboardingHeld() { return held; }

export function setOnboardingHold(next) {
    const v = Boolean(next);
    if (v === held) return;
    held = v;
    [...listeners].forEach((fn) => fn());
}

function subscribe(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
}

/** Resolves at once when nothing holds, else when the hold is released. */
export function whenOnboardingReleased() {
    if (!held) return Promise.resolve();
    return new Promise((resolve) => {
        const off = subscribe(() => { if (!held) { off(); resolve(); } });
    });
}

/** Whether the first read's wait is on screen; re-renders when it changes. */
export function useOnboardingHold() {
    return useSyncExternalStore(subscribe, isOnboardingHeld, isOnboardingHeld);
}
